import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { SourceEventOption } from '@app/v2/event/types/add-from-other-event.type'

@Component({
  selector: 'app-source-event-option',
  standalone: true,
  imports: [NgClass],
  templateUrl: './source-event-option.component.html',
  host: {
    class: 'tw-flex tw-min-w-0 tw-flex-col tw-gap-0.5 tw-text-start tw-font-inter'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourceEventOptionComponent {
  public readonly option = input.required<SourceEventOption>()
}
